import Dispatcher from "../../../flux/dispatcher/dispatcher";
import { EventEmitter } from "events";
import Constant from "../Constants";
import assign from "object-assign";

const RESPONSE_CHANGE_EVENT = "globalResponse";

let response = {};

function parseResponse(resp) {
  let newResp = { updateMessage: resp.message, status: resp.status };
  response = newResp;
}

const UpdateBlockedDomainStore = assign({}, EventEmitter.prototype, {
  emitChangeEvent: function (event) {
    this.emit(event);
  },
  bind: function (callback) {
    this.on(RESPONSE_CHANGE_EVENT, callback);
  },
  unbind: function (callback) {
    this.removeListener(RESPONSE_CHANGE_EVENT, callback);
  },
  getResponse: function () {
    return response;
  },
});

Dispatcher.register(function (action) {
  switch (action.actionType) {
    case Constant.DELETE_BLOCKED_PUBLIC_EMAIL_DOMAIN:
      const resp = action.data;
      parseResponse(resp);
      UpdateBlockedDomainStore.emitChangeEvent(
        RESPONSE_CHANGE_EVENT
      );
      break;
    default:
  }
});

export default UpdateBlockedDomainStore;
